import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Input from '../../layout/input/Input';
import InputCheckBox from '../../layout/input/InputCheckBox';
import InputMasked from '../../layout/input/InputMasked';
import InputPassword from '../../layout/input/InputPassword';
import InputShow from '../../layout/input/InputShow';
import Panel from '../../layout/panel/Panel';
import ButtonCol from '../../layout/button/ButtonCol';
import MyModal from '../../layout/modal/MyModal';
import ModalChangeSenha from './ModalChangeSenha';

import SistemaService from '../../../service/SistemaService';
import AutenticarService from '../../../service/AutenticarService';

class Dedicada extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModalChangeSenhaCPanel: false,
            
            preloadCPanel: false,

            showModalChangeSenhaDB: false,

            preloadDB: false,

            showSenha: '',

            showSenhaHeader: ''
        }        
    }

    onButtonSenhaCPanelClick() {
        this.setState({preloadCPanel: false});

        SistemaService.getSenhaCPanel(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {
            this.setState({
                preloadCPanel: false,
                showSenha: resposta.data.senha,
                showSenhaHeader: 'Senha CPanel'
            });
        }).catch(erro => {
            this.props.onErro(this.trataErro(erro));
            this.setState({preloadCPanel: false});
        });
    }

    onButtonSenhaDBClick() {
        this.setState({preloadDB: false});

        SistemaService.getSenhaDB(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {
            this.setState({
                preloadDB: false,
                showSenha: resposta.data.senha,
                showSenhaHeader: 'Senha Banco de dados do CPanel'
            });
        }).catch(erro => {
            this.props.onErro(this.trataErro(erro));
            this.setState({preloadDB: false});
        });
    }

    render() {
        return(
            <Fragment>
                <ModalChangeSenha
                    show={this.state.showModalChangeSenhaCPanel}
                    header="Alteração da senha do CPanel"

                    service={SistemaService.atualizarSenhaCPanel}
                    id={this.props.form.id}
                    
                    onSucesso={() => this.setState({ showModalChangeSenhaCPanel: false })}
                    fechar={() => this.setState({ showModalChangeSenhaCPanel: false })}
                />

                <ModalChangeSenha
                    show={this.state.showModalChangeSenhaDB}
                    header="Alteração da senha do banco de dados do CPanel"

                    service={SistemaService.atualizarSenhaDB}
                    id={this.props.form.id}
                    
                    onSucesso={() => this.setState({ showModalChangeSenhaDB: false })}
                    fechar={() => this.setState({ showModalChangeSenhaDB: false })}
                />

                <MyModal
                    show={this.state.showSenha !== ''}
                    header={this.state.showSenhaHeader}
                    texto={this.state.showSenha}
                    buttonTxt="Ok"
                    
                    fechar={() => this.setState({showSenha: '', showSenhaHeader: ''})}
                />

                <Input
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="dominio"
                    nome="dominio"
                    value={this.props.form.dominio}                     
                    defaultFoco={true}
                    erro={this.props.erroForm.dominio}
                    onChange={(e) => this.props.onChange(e)}
                >                    
                    Informe seu domínio
                </Input>

                <InputCheckBox
                    md={12} 
                    xs={12}
                    sm={12} 
                    lg={12}
                    id="instalar_subdominio"
                    nome="instalar_subdominio"
                    value={this.props.form.instalar_subdominio}                     
                    checked={parseInt(this.props.form.instalar_subdominio, 10) === 1}                                       
                    onChange={(e) => this.props.onInstalarSubdominioChange(e)}                   
                >                    
                    Instalar em um Subdominio
                </InputCheckBox>

                <InputMasked
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="subdominio"
                    nome="subdominio"
                    value={this.props.form.subdominio}                                 
                    pattern="[a-zA-Z0-9\-\_]+$"
                    disabled={parseInt(this.props.form.instalar_subdominio, 10) === 0}
                    erro={this.props.erroForm.subdominio}
                    onChange={(e) => this.props.onChange(e)}
                >                    
                    Nome do diretório
                </InputMasked>

                <Panel 
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    title="Informe os dados de acesso ao CPanel do seu servidor de hospedagem"
                >
                    <InputShow
                        md={6} 
                        xs={6} 
                        sm={6} 
                        lg={6}
                        id="usuario_c_panel"
                        nome="usuario_c_panel"
                        showButton={this.props.usuario.admin && this.props.form.dbuser_c_panel}
                        preload={this.state.preloadCPanel}
                        value={this.props.form.usuario_c_panel}                        
                        erro={this.props.erroForm.usuario_c_panel}
                        onChange={(e) => this.props.onChange(e)}  
                        onButtonClick={() => this.onButtonSenhaCPanelClick()}
                    >                    
                        Usuário
                    </InputShow>

                    {
                        !this.props.form.usuario_c_panel &&
                        <Input
                            md={6} 
                            xs={6} 
                            sm={6} 
                            lg={6}
                            id="senha_c_panel"
                            nome="senha_c_panel"
                            value={this.props.form.senha_c_panel}                             
                            erro={this.props.erroForm.senha_c_panel}  
                            onChange={(e) => this.props.onChange(e)}                 
                        >                    
                            Senha
                        </Input>
                    }

                    {
                        this.props.form.usuario_c_panel &&                         
                        <ButtonCol
                            md={6}
                            xs={12}
                            sm={6}
                            lg={6}
                            id="btnSenhaCPanel"
                            nome="btnSenhaCPanel"                                
                            onClick={() => this.setState({showModalChangeSenhaCPanel: true})}
                        >
                            ALTERAR SENHA
                        </ButtonCol>                        
                    }
                </Panel>

                <Panel 
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    title="Informe os dados de acesso ao Banco de Dados"
                >
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="dbname_c_panel"
                        nome="dbname_c_panel"
                        value={this.props.form.dbname_c_panel}                        
                        erro={this.props.erroForm.dbname_c_panel}
                        onChange={(e) => this.props.onChange(e)}                   
                    >                    
                        Banco de Dados
                    </Input>

                    <InputShow
                        md={6} 
                        xs={6} 
                        sm={6} 
                        lg={6}
                        id="dbuser_c_panel"
                        nome="dbuser_c_panel" 
                        showButton={this.props.usuario.admin && this.props.form.dbuser_c_panel}
                        preload={this.state.preloadDB}
                        value={this.props.form.dbuser_c_panel}                         
                        erro={this.props.erroForm.dbuser_c_panel}  
                        onChange={(e) => this.props.onChange(e)} 
                        onButtonClick={() => this.onButtonSenhaDBClick()}                
                    >                    
                        Usuário
                    </InputShow>

                    {   
                        !this.props.form.dbuser_c_panel &&
                        <InputPassword
                            md={6} 
                            xs={6} 
                            sm={6} 
                            lg={6}                            
                            id="dbsenha_c_panel"
                            nome="dbsenha_c_panel"
                            value={this.props.form.dbsenha_c_panel}                             
                            erro={this.props.erroForm.dbsenha_c_panel}  
                            onChange={(e) => this.props.onChange(e)}                 
                        >                    
                            Senha
                        </InputPassword>
                    }

                    {
                        this.props.form.dbuser_c_panel &&                                                    
                        <ButtonCol
                            md={6}
                            xs={12}
                            sm={6}
                            lg={6}
                            id="btnSenhaDB"
                            nome="btnSenhaDB"                                
                            onClick={() => this.setState({showModalChangeSenhaDB: true})}
                        >
                            ALTERAR SENHA
                        </ButtonCol>                        
                    }
                </Panel>
            </Fragment>            
        )
    }
}

export default Dedicada;